import { DownOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { usePDF } from "@react-pdf/renderer";
import {
  Button,
  Col,
  Collapse,
  Dropdown,
  Input,
  Menu,
  Modal,
  Popover,
  Row,
  Steps,
  Typography,
  message,
} from "antd";
import Text from "antd/lib/typography/Text";
import _ from "lodash";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import { expenseFields } from "../../actions/expenses/expenses";
import { reportDetailsPDF, userReport } from "../../actions/reports";
import { userReportLinkTripReset } from "../../actions/trips";
import block from "../../assets/icons/block.png";
import Close from "../../assets/icons/close.png";
import Comment from "../../assets/icons/comment.png";
import ErrorActive from "../../assets/icons/error_active.png";
import History from "../../assets/icons/time_icon.png";
import warn from "../../assets/icons/warning.png";
import { apis } from "../../config/APIs";
import endpoint from "../../config/Axios";
import {
  amountFormat,
  getBoolVal,
  hasAccess,
  isSuperAdmin,
  objectToFormData,
} from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import NoCommentsComponent from "../Common/NoComentsComponent";
import NodataComponent from "../Common/NodataComponent";
import ReportsOne from "../Common/PDF/PDFReportsTemplates/ReportsOne";
import {
  ReportsCommentsAdd,
  UserReport,
  UserReportLinkExp,
  UserReportRecall,
  UserReportSubmit,
  reportsAdvance,
  reportsApprove,
  reportsApproveReset,
  reportsComments,
  reportsCommentsAdd,
  reportsExpDetails,
  reportsExportExcel,
  // reports,
  reportsHistory,
  reportsReimburse,
  reportsReimburseReset,
  reportsReject,
  reportsRejectReset,
  reportsTrips,
  userReportLinkAdvReset,
  userReportLinkExp,
  userReportRecall,
  userReportSubmit,
} from "./../../actions/reports/reports";
import AddExpenses from "./../Expenses/AddExpenses";
import PageHeader from "./../PageHeader";
import AddReport from "./AddReport";
import Expenses from "./Expenses";
import LinkAdvances from "./LinkAdvances";
import LinkExpenses from "./LinkExpenses";
import LinkTrips from "./LinkTrips";
import ReimburseModal from "./ReimburseModal";
import ReportAdvances from "./ReportAdvances";
import ReportTrips from "./ReportTrips";
import "./report.css";
import Loader from "../Loader";

const { Panel } = Collapse;
const { TextArea } = Input;
const { Step } = Steps;
const Title = Typography.Title;
message.config({
  maxCount: 3,
});

const formatCommentTimestamp = (createdAt) => {
  if (!createdAt) {
    return "-";
  }

  const parsedDate = moment(
    createdAt,
    [
      "DD-MM-YYYY,HH:mm:ss",
      "DD-MM-YYYY, HH:mm:ss",
      "DD-MM-YYYY HH:mm:ss",
      "YYYY-MM-DD HH:mm:ss",
      moment.ISO_8601,
    ],
    true,
  );

  if (parsedDate.isValid()) {
    return parsedDate.format("DD-MM-YYYY, HH:mm:ss");
  }

  const fallbackDate = moment(createdAt);
  return fallbackDate.isValid()
    ? fallbackDate.format("DD-MM-YYYY, HH:mm:ss")
    : createdAt;
};

const ReportDetail = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  // const {
  //   location: { state: { reportData = {} } = {} },
  // } = history;
  const reportData = useSelector(
    (state) => state?.reports?.userReportShow?.data?.response?.report,
  );
  const reportLoading = useSelector(
    (state) => state?.reports?.userReportShow?.loading,
  );
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [reimburseModalVisible, setReimburseModalVisible] =
    React.useState(false);
  const [expensesData, setExpensesData] = React.useState([]);
  const [commentsData, setCommentsData] = React.useState([]);
  const [reportsHistoryData, setReportsHistoryData] = React.useState([]);
  const [reportsAdvanceData, setReportsAdvanceData] = React.useState([]);
  const [reportsTripData, setReportsTripData] = React.useState([]);
  const [reportErrors, setReportErrors] = React.useState([]);
  const [reasonValue, setReasonValue] = React.useState("");
  const [modalType, setModalType] = React.useState("");
  const [expensesFieldsData, setExpensesFieldsData] = React.useState([]);
  const [input, setInput] = React.useState("");
  const [violations, setViolations] = React.useState([]);
  const [showViolations, setShowViolations] = React.useState(false);
  const [isURL, setIsURL] = React.useState("");

  const expensesResponse = useSelector(
    (state) => state.reports.reportsExpDetails || {},
  );
  const resetFormRef = useRef();
  const reportsCommentsResponse = useSelector(
    (state) => state.reports.reportsComments || {},
  );

  const reportsCommentsAddResponse = useSelector(
    (state) => state.reports.reportsCommentsAdd || {},
  );
  const reportsRejectResponse = useSelector(
    (state) => state.reports.reportsReject || {},
  );
  const reportsApproveResponse = useSelector(
    (state) => state.reports.reportsApprove || {},
  );
  const reportsReimburseResponse = useSelector(
    (state) => state.reports.reportsReimburse || {},
  );
  const reportsExportExcelResponse = useSelector(
    (state) => state.reports.reportsExportExcel || {},
  );
  const reportsHistoryResponse = useSelector(
    (state) => state.reports.reportsHistory || {},
  );
  const reportsAdvanceResponse = useSelector(
    (state) => state.reports.reportsAdvance || {},
  );
  const reportsTripsResponse = useSelector(
    (state) => state.reports.reportsTrips || {},
  );

  const expenseFieldsResponse = useSelector(
    (state) => state.expenses.expenseFields || {},
  );
  const addExpenseResponse = useSelector(
    (state) => state.expenses.addExpense || {},
  );
  const userReportLinkAdvResponse = useSelector(
    (state) => state.reports.userReportLinkAdv || {},
  );
  const userReportLinkTripResponse = useSelector(
    (state) => state.trips.userReportLinkTrips || {},
  );
  // const reportPDFURL = useSelector(
  //   (state) => state.reports.reportdetailsPdf?.data?.response?.report_url || ""
  // );
  const userReportLinkExpResponse = useSelector(
    (state) => state.reports.userReportLinkExp || {},
  );
  const userReportSubmitResponse = useSelector(
    (state) => state.reports.userReportSubmit || {},
  );
  const userReportRecallResponse = useSelector(
    (state) => state.reports.userReportRecall || {},
  );

  const [instance, updateInstance] = usePDF({
    document: (
      <ReportsOne
        data={reportData}
        tripsHistory={reportsHistoryResponse?.data?.response?.history}
        CommentsData={reportsCommentsResponse?.data?.response?.comments}
        advanceData={reportsAdvanceResponse?.data?.response?.advances}
        expensesData={expensesData}
        tripData={reportsTripData?.[0]}
      />
    ),
  });

  useEffect(() => {
    updateInstance(
      <ReportsOne
        data={reportData}
        tripsHistory={reportsHistoryResponse?.data?.response?.history}
        CommentsData={reportsCommentsResponse?.data?.response?.comments}
        advanceData={reportsAdvanceResponse?.data?.response?.advances}
        expensesData={expensesData}
        tripData={reportsTripData?.[0]}
      />,
    );
  }, [
    reportData,
    reportsHistoryResponse,
    reportsCommentsResponse,
    reportsAdvanceResponse,
    expensesData,
    reportsTripData,
  ]);

  const [isReportModalVisible, setIsReportModalVisible] = React.useState(false);

  const params = useParams();
  const is_admin = getBoolVal(sessionStorage.getItem("is_admin"));

  const callOnMount = () => {
    if (params.id) {
      dispatch(
        reportsTrips(
          { report_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(
        reportsExpDetails(
          { report_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(
        reportsComments(
          { report_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(
        reportsHistory(
          { report_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(
        reportsAdvance(
          { report_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(expenseFields());
      dispatch(
        reportDetailsPDF({
          report_id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );

      dispatch(
        userReport({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
    }
  };

  React.useEffect(() => {
    callOnMount();

    return () => {
      setReportErrors([]);
      dispatch({
        type: UserReport.RESET,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { status = "", message: res_message = "" } = {} } =
      userReportLinkExpResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(
        reportsExpDetails(
          { report_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(
        userReport({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      dispatch({
        type: UserReportLinkExp.RESET,
      });
    } else if (status === false) {
      setIsModalVisible(false);
      dispatch({
        type: UserReportLinkExp.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkExpResponse]);

  React.useEffect(() => {
    const { data: { status = false, message: res_message = "" } = {} } =
      userReportSubmitResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch({
        type: UserReportSubmit.RESET,
      });
      dispatch(
        userReport({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportSubmitResponse]);

  React.useEffect(() => {
    const { data: { status = false, message: res_message = "" } = {} } =
      userReportRecallResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(
        userReport({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      dispatch({
        type: UserReportRecall.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportRecallResponse]);

  React.useEffect(() => {
    const {
      data: {
        status = "",
        response: { transaction: { id = "" } = {} } = {},
      } = {},
    } = addExpenseResponse;
    if (status) {
      setIsModalVisible(false);
      if (resetFormRef.current) {
        resetFormRef.current();
      }
      const payload = {};
      payload.transactions = [id];
      payload.report_id = params.id;
      endpoint
        .post(
          apis.validate_expense,
          {
            transaction_ids: payload.transactions,
          },
          { skipSuccessMessage: true },
        )
        .then((res) => {
          let txns = res.data?.response?.transactions || [];
          let policies = [];
          txns?.forEach((ele) => {
            policies = [
              ...policies,
              ...ele?.policies?.map((e) => e.is_blocked && e.errors?.length),
            ];
          });

          if (policies?.filter((ele) => ele)?.length) {
            setShowViolations(true);
            setViolations(txns);
          } else {
            dispatch(userReportLinkExp(objectToFormData(payload)));
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addExpenseResponse]);

  React.useEffect(() => {
    const { data: { status = false, message: res_message = "" } = {} } =
      userReportLinkAdvResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(
        reportsAdvance(
          { report_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(
        userReport({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      dispatch(userReportLinkAdvReset());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkAdvResponse]);

  React.useEffect(() => {
    const { data: { status = false, message: res_message = "" } = {} } =
      userReportLinkTripResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(
        reportsTrips(
          { report_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(userReportLinkTripReset());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkTripResponse]);

  React.useEffect(() => {
    const { data: { response: { fields = [] } = {}, status = false } = {} } =
      expenseFieldsResponse;
    if (status) {
      setExpensesFieldsData(fields);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expenseFieldsResponse]);

  React.useEffect(() => {
    const {
      data: { response: { transactions = [] } = {}, status = false } = {},
    } = expensesResponse;
    if (status) {
      setExpensesData(transactions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expensesResponse]);

  React.useEffect(() => {
    const { data: { response: { comments = [] } = {}, status = false } = {} } =
      reportsCommentsResponse;
    if (status) {
      setCommentsData(comments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsCommentsResponse]);

  React.useEffect(() => {
    const { data: { response: { history = [] } = {}, status = false } = {} } =
      reportsHistoryResponse;
    if (status) {
      setReportsHistoryData(history);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsHistoryResponse]);

  React.useEffect(() => {
    const { data: { response: { advances = [] } = {}, status = false } = {} } =
      reportsAdvanceResponse;
    if (status) {
      setReportsAdvanceData(advances);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsAdvanceResponse]);

  React.useEffect(() => {
    const { data: { response: { trips = [] } = {}, status = false } = {} } =
      reportsTripsResponse;
    if (status) {
      setReportsTripData(trips);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsTripsResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      reportsCommentsAddResponse;
    if (status) {
      dispatch(
        reportsComments(
          { report_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch({
        type: ReportsCommentsAdd.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsCommentsAddResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      reportsExportExcelResponse;
    if (status) {
      // dispatch(reportsComments({ report_id: params.id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsExportExcelResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      reportsRejectResponse;
    if (status) {
      setIsModalVisible(false);
      // dispatch(reports(objectToFormData({ status: true })));
      dispatch(reportsRejectReset());
      dispatch(
        userReport({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      if (modalType === "delete") {
        history.push("/reports");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsRejectResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      reportsApproveResponse;
    if (status) {
      // dispatch(reports(objectToFormData({ status: true })));
      dispatch(reportsApproveReset());
      dispatch(
        userReport({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsApproveResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      reportsReimburseResponse;
    if (status) {
      // dispatch(reports(objectToFormData({ status: true })));
      dispatch(reportsReimburseReset());
      setReimburseModalVisible(false);
      dispatch(
        userReport({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
    } else if (status === false) {
      dispatch(reportsReimburseReset());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsReimburseResponse]);

  React.useEffect(() => {
    if (reportData?.expense_errors?.report) {
      let arr = [];
      reportData?.expense_errors?.report?.forEach((ele) =>
        ele?.policies?.forEach((itm) =>
          itm.errors?.forEach((item) => arr.push(item)),
        ),
      );
      setReportErrors(arr);
    } else {
      setReportErrors([]);
    }
  }, [reportData]);

  const handleAddComment = () => {
    if (input?.trim() && params.id) {
      dispatch(
        reportsCommentsAdd({
          body: input,
          report_id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      setInput("");
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsReportModalVisible(false);
    setReportErrors([]);
    if (resetFormRef.current) {
      resetFormRef.current();
    }
  };

  const renderDeleteOption = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(reportsReject({ id: params.id, isDelete: true }));
        }}
      >
        <Text>Are you sure you want to delete report ?</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          htmlType="submit"
          disabled={reportsRejectResponse?.loading}
        >
          Confirm
        </Button>
        <Button
          key="2"
          htmlType="button"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </form>
    );
  };

  const renderRejectOption = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(
            reportsReject(
              objectToFormData({ id: params.id, reason: reasonValue }),
            ),
          );
        }}
      >
        <Text>Please specify an appropriate reason for rejection.</Text>
        <br />
        <TextArea
          rows={4}
          placeholder="Enter Reason"
          className="reasonTextArea"
          onChange={(e) => setReasonValue(e.target.value)}
          required={true}
        />
        <br />
        <Button
          key="1"
          className="formButton mt1"
          htmlType="submit"
          disabled={!reasonValue || reportsRejectResponse?.loading}
        >
          Confirm
        </Button>
        <Button
          key="2"
          htmlType="button"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </form>
    );
  };

  const renderUnrepOption = () => {
    return (
      <>
        <LinkExpenses report_id={params.id} />
      </>
    );
  };

  const renderUnrepAdvOption = () => {
    return (
      <>
        <LinkAdvances report_id={params.id} />
      </>
    );
  };

  const renderUnrepTripOption = () => {
    return (
      <>
        <LinkTrips report_id={params.id} />
      </>
    );
  };

  function handleMenuClick(e) {
    switch (e.key) {
      case "1":
        // if (reportPDFURL)
        //   saveAs(reportPDFURL, "ReportDetail.pdf")
        // else
        break;
      case "3":
        dispatch(reportsExportExcel({ id: params.id }));
        break;
      default:
    }
  }

  const menu = (
    <Menu onClick={handleMenuClick}>
      {/* <Menu.Item key="1">Download PDF</Menu.Item>
      {expensesData?.filter(ele => ele?.files?.length > 0)?.length > 0 && <Menu.Item
        key="2"
        onClick={() => {
          let arr = [];
          expensesData?.forEach((ele) => {
            if (ele?.files?.length) arr = [...arr, ...ele.files];
          });
          if (arr.length) downloadAndZip(arr);
        }}
      >
        Download Receipts
      </Menu.Item>} */}
      <Menu.Item
        key="1"
        disabled={!isURL}
        title={!isURL ? "PDF is not there for this trip" : ""}
        onClick={() => {
          window.open(isURL, "_blank");
        }}
      >
        Download PDF
      </Menu.Item>
      {/* <Menu.Item key="3">Export to Excel</Menu.Item>
      <Menu.Item key="4">Print</Menu.Item> */}
    </Menu>
  );

  const content =
    reportData?.total_amount - reportData?.total_advances_amount > 0 &&
      reportData?.reimbursement ? (
      <div className="pop-card">
        <p>
          <span>
            Reference &nbsp;&nbsp;&nbsp;&nbsp; <br />
          </span>
          <span className="dim">{reportData?.reimbursement.reference}</span>
        </p>
        <p>
          <span>
            Reimbursed on &nbsp;&nbsp;&nbsp;&nbsp; <br />
          </span>
          <span className="dim">
            {moment(reportData?.reimbursement.reimbursed_on).format(
              "DD-MM-YYYY HH:mm",
            )}
          </span>
        </p>
        <p>
          <span>
            Billing To
            <br />
          </span>
          <span className="dim">{reportData?.reimbursement.billing_to}</span>
        </p>
        <p>
          <span>
            Mode &nbsp;&nbsp;&nbsp;&nbsp; <br />
          </span>
          <span className="dim">{reportData?.reimbursement.mode}</span>
        </p>
        <p>
          <span>
            Notes &nbsp;&nbsp;&nbsp;&nbsp; <br />
          </span>
          <span className="dim">{reportData?.reimbursement.notes}</span>
        </p>
      </div>
    ) : (
      <div className="pop-card">
        <p>
          <span>
            Total Expense Amount &nbsp;&nbsp;&nbsp;&nbsp; <br />
          </span>
          <span className="dim">
            <BaseCurrency /> {amountFormat(reportData?.total_amount) || 0}
          </span>
        </p>
        <p>
          <span>
            Non-reimbursable Amount &nbsp;&nbsp;&nbsp;&nbsp; <br />
          </span>
          <span className="dim">
            <BaseCurrency />{" "}
            {amountFormat(reportData?.total_non_reimbursable_amount) || 0}
          </span>
        </p>
        <p>
          <span>
            Advance Amount &nbsp;&nbsp;&nbsp;&nbsp; <br />
          </span>
          <span className="dim">
            <BaseCurrency />{" "}
            {amountFormat(reportData?.total_advances_amount) || 0}
          </span>
        </p>
        <p>
          <span>
            {reportData?.status === "reimbursed"
              ? "Reimbursed Amount"
              : "Amount to be Reimbursed"}
            <br />
          </span>
          <span className="dim">
            <BaseCurrency />{" "}
            {amountFormat(
              reportData?.total_amount -
              reportData?.total_non_reimbursable_amount -
              reportData?.total_advances_amount,
            ) || 0}
          </span>
        </p>
        <p>
          <span>
            Advance Refunds &nbsp;&nbsp;&nbsp;&nbsp; <br />
          </span>
          <span className="dim">
            <BaseCurrency />{" "}
            {amountFormat(
              reportData?.advance_refunds?.length
                ? _.sumBy(reportData?.advance_refunds, "amount_cents")
                : 0,
            )}
          </span>
        </p>
      </div>
    );

  const renderModalData = (type) => {
    switch (type) {
      case "delete":
        return renderDeleteOption();
      case "reject":
        return renderRejectOption();
      case "addNewExp":
        return (
          <AddExpenses
            expensesFieldsData={expensesFieldsData}
            setAddOption={setIsModalVisible}
            handleCancel={handleCancel}
            setViolations={setViolations}
            setShowViolations={setShowViolations}
            reportId={reportData?.id}
            isModalVisible={isModalVisible}
            resetForm={(resetForm) => {
              resetFormRef.current = resetForm;
            }}
          />
        );
      case "addUnrepExp":
        return renderUnrepOption();
      case "addUnrepAdvance":
        return renderUnrepAdvOption();
      case "addUnrepTrip":
        return renderUnrepTripOption();
      default:
        return "";
    }
  };

  const renderModalTitle = (type) => {
    switch (type) {
      case "delete":
        return "Reject Report";
      case "addNewExp":
        return "";
      case "addUnrepExp":
        return "Add Expenses to Report";
      case "addUnrepAdvance":
        return "Add Advance to Report";
      case "addUnrepTrip":
        return "Add Trip to Report";
      default:
        return "";
    }
  };

  const renderModalClass = (type) => {
    switch (type) {
      case "delete":
        return "center-aligned-modal";
      case "addNewExp":
        return "center-aligned-modal-big expense";
      case "addUnrepExp":
        return "right-alinged-modal";
      case "addUnrepAdvance":
        return "right-alinged-modal";
      case "addUnrepTrip":
        return "right-alinged-modal";
      default:
        return "";
    }
  };
  const emp_id = sessionStorage.getItem("employee_id");

  React.useEffect(() => {
    if (!instance.loading && instance.url) {
      setIsURL(instance.url);
    }
  }, [instance]);

  return (
    <>
      {reportLoading ? <Loader /> : null}
      <div className="heading-div">
        <PageHeader
          title={`Reports`}
          navigation={{
            Home:
              hasAccess("dashboard", "read") || hasAccess("dashboard", "write")
                ? "/dashboard"
                : "",
            Reports: "/reports/",
          }}
        />
      </div>
      <>
        {(Array.isArray(reportData?.report_appovers_data) &&
          reportData?.report_appovers_data?.includes(emp_id)) ||
          is_admin ||
          reportLoading ||
          !reportData ? (
          <div className="report-detail detail-card mb4">
            {isModalVisible && (
              <Modal
                title={renderModalTitle(modalType)}
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={[]}
                className={renderModalClass(modalType)}
              >
                {renderModalData(modalType)}
              </Modal>
            )}

            {isReportModalVisible && (
              <Modal
                title={
                  <Title level={4}>
                    Edit Report &nbsp;
                    <span className="text-small">Enter details and submit</span>
                  </Title>
                }
                visible={isReportModalVisible}
                onCancel={handleCancel}
                footer={[]}
                className="right-alinged-modal"
              >
                <AddReport
                  handleCancel={handleCancel}
                  report={reportData}
                  callOnMount={callOnMount}
                />
              </Modal>
            )}
            <section className="head">
              <div className="flex-between">
                <div className="v-center">
                  <h3>{reportData?.title}</h3>
                  <span
                    className={`status status_${is_admin
                        ? reportData?.current_report_status
                        : reportData?.status
                      }`}
                  >
                    {is_admin
                      ? reportData?.current_report_status?.replace(/_/g, " ")
                      : reportData?.status?.replace(/_/g, " ")}
                  </span>
                </div>
                <div className="d-flex action-btns">
                  {getBoolVal(sessionStorage.getItem("is_admin")) ? (
                    <>
                      {hasAccess("expense_reports", "write") &&
                        (!reportData?.action_restrict || isSuperAdmin()) &&
                        reportData?.current_report_status ===
                        "pending_approval" ? (
                        <>
                          <button
                            className="approve"
                            disabled={reportsApproveResponse?.loading}
                            onClick={() => {
                              dispatch(
                                reportsApprove(
                                  objectToFormData({ id: params.id }),
                                ),
                              );
                            }}
                          >
                            Approve
                          </button>
                          <button
                            className="reject"
                            onClick={() => {
                              setIsModalVisible(true);
                              setModalType("reject");
                            }}
                          >
                            Reject
                          </button>
                        </>
                      ) : null}
                      {reportData?.current_report_status ===
                        "pending_reimbursement" &&
                        (!reportData?.action_restrict || isSuperAdmin()) &&
                        hasAccess("expense_reports", "write") ? (
                        <>
                          <button
                            className="approve"
                            onClick={() => {
                              setReimburseModalVisible(true);
                            }}
                          >
                            Reimburse
                          </button>
                          <button
                            className="reject"
                            onClick={() => {
                              setIsModalVisible(true);
                              setModalType("reject");
                            }}
                          >
                            Reject
                          </button>
                        </>
                      ) : null}
                    </>
                  ) : (
                    <>
                      {reportData?.status === "unsubmitted" &&
                        hasAccess("expense_reports", "write") ? (
                        <>
                          <button
                            className="approve"
                            disabled={
                              userReportSubmitResponse?.loading ||
                              !expensesData?.length
                            }
                            onClick={() => {
                              endpoint
                                .post(
                                  apis.validate_expense,
                                  {
                                    report_id: params.id,
                                  },
                                  { skipSuccessMessage: true },
                                )
                                .then((res) => {
                                  let txns = res.data?.response?.report || [];
                                  let policies = [];
                                  txns?.forEach((ele) => {
                                    policies = [
                                      ...policies,
                                      ...ele?.policies?.map(
                                        (e) => e.is_blocked && e.errors?.length,
                                      ),
                                    ];
                                  });

                                  if (policies?.filter((ele) => ele)?.length) {
                                    setShowViolations(true);
                                    setViolations(txns);
                                  } else {
                                    dispatch(
                                      userReportSubmit(
                                        objectToFormData({ id: params.id }),
                                        {
                                          is_admin: getBoolVal(
                                            sessionStorage.getItem("is_admin"),
                                          ),
                                        },
                                      ),
                                    );
                                  }
                                });
                            }}
                          >
                            Submit
                          </button>
                          <button
                            className="reject"
                            onClick={() => {
                              setIsReportModalVisible(true);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            className="delete"
                            onClick={() => {
                              setIsModalVisible(true);
                              setModalType("delete");
                            }}
                          >
                            Delete
                          </button>
                        </>
                      ) : null}
                      {hasAccess("expense_reports", "write") &&
                        reportData?.recallable &&
                        reportData?.status === "pending_approval" ? (
                        <>
                          <button
                            className="reject"
                            disabled={userReportRecallResponse?.loading}
                            onClick={() =>
                              dispatch(
                                userReportRecall({
                                  id: params.id,
                                  is_admin: getBoolVal(
                                    sessionStorage.getItem("is_admin"),
                                  ),
                                }),
                              )
                            }
                          >
                            Recall
                          </button>
                        </>
                      ) : null}
                    </>
                  )}

                  <Dropdown overlay={menu} placement="bottomRight">
                    <button className="more">
                      More&nbsp;
                      <DownOutlined />
                    </button>
                  </Dropdown>

                  <span
                    className="close cursor"
                    onClick={() => {
                      history.push("/reports/", {
                        status: location.state.status,
                      });
                    }}
                  >
                    <img src={Close} width={20} alt={"close"} />
                  </span>
                </div>
              </div>
              <div>
                <span className="duration">
                    Duration : {
                    reportData?.from_date &&
                    moment(reportData.from_date, "DD-MM-YYYY HH:mm:ss", true).isValid()
                      ? moment(reportData.from_date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY, HH:mm:ss")
                      : ""
                  } 
                  - {
                    reportData?.to_date &&
                    moment(reportData.to_date, "DD-MM-YYYY HH:mm:ss", true).isValid()
                      ? moment(reportData.to_date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY, HH:mm:ss")
                      : ""
                  }
                </span>
              </div>
            </section>
            <hr />
            {reportErrors?.length > 0 && (
              <section className="report-error forReport p1">
                <p>{reportData.report_number}</p>
                {reportErrors?.map((itm) => (
                  <p>
                    <img src={ErrorActive} alt="" className="mr1" />
                    {itm}
                  </p>
                ))}
              </section>
            )}

            <section className="report-info">
              <div className="title-card d-flex">
                <p>
                  <span>
                    Submitted by :<br />
                    {reportData?.submitted_by}
                  </span>
                  <span className="sm">
                    on {reportData?.submitted_on
                      ? moment(reportData.submitted_on).format("DD-MM-YYYY, HH:mm:ss")
                      : "-"}
                  </span>
                </p>
                <p>
                  <span>
                    Submitted to :<br />
                  </span>
                  <span>
                    {reportData?.submitted_to_email || reportData?.submitted_to}
                  </span>
                </p>
                {(reportData?.status === "pending_approval" ||
                  reportData?.status === "pending_reimbursement") && (
                    <p>
                      <span>
                        Pending approval :<br />
                      </span>
                      <span className="dim">
                        {reportData?.pending_approval_by || reportData?.email}
                      </span>
                    </p>
                  )}
              </div>
              <div className="report-total title-card">
                <p>
                  <label>Report Total</label>
                  <span className="lg">
                    <BaseCurrency />{" "}
                    {amountFormat(reportData?.total_amount) || 0}
                  </span>
                </p>
                <p>
                  <label>
                    {reportData?.status === "reimbursed"
                      ? "Reimbursed Amount"
                      : "Amount to be Reimbursed"}
                  </label>
                  <span className="lg">
                    <BaseCurrency />{" "}
                    {amountFormat(
                      reportData?.total_amount -
                      reportData?.total_non_reimbursable_amount -
                      reportData?.total_advances_amount,
                    ) || 0}
                  </span>
                  <Popover
                    placement="bottomRight"
                    title="Summary"
                    content={content}
                    trigger="click"
                    className="summaryCard"
                  >
                    <span className="link cursor">View Summary</span>
                  </Popover>
                </p>
              </div>
            </section>
            <section className="business-info">
              <div className="title-card">
                {reportData?.custom_fields?.map(({ key, value }) => (
                  <p>
                    <span className="capitalize">
                      {key || "_"}:<br />
                    </span>
                    <span className="dim">{value || "_"}</span>
                  </p>
                ))}
              </div>
            </section>
            <div className="ml2 mr2 mt1 mb1">
              <Collapse bordered={false} defaultActiveKey={["1"]}>
                {reportData?.status !== "unsubmitted" ||
                  getBoolVal(sessionStorage.getItem("is_admin")) ? null : (
                  <div className="floatRightButtons mr1">
                    <Button
                      key="2"
                      className="cancelButton ml1 mt1"
                      onClick={() => {
                        setIsModalVisible(true);
                        setModalType("addUnrepExp");
                      }}
                    >
                      Add Unreported Expenses
                    </Button>
                    <Button
                      key="15"
                      className="mt1 primaryButton"
                      onClick={() => {
                        setIsModalVisible(true);
                        setModalType("addNewExp");
                      }}
                    >
                      <PlusCircleOutlined /> New Expense
                    </Button>
                  </div>
                )}
                <Panel
                  header={
                    <span>
                      Expenses <strong>{expensesData.length}</strong>
                    </span>
                  }
                  key="1"
                >
                  {expensesData.length ? (
                    <>
                      <Expenses
                        isLastExpense={expensesData.length === 1}
                        expensesData={expensesData}
                        showReject={
                          reportData?.status === "pending_approval" &&
                          hasAccess("expense_reports", "write")
                        }
                        showDelete={
                          reportData?.status === "unsubmitted" &&
                          hasAccess("expense_reports", "write")
                        }
                        callExpenseDetails={() => {
                          dispatch(
                            userReport({
                              id: params.id,
                              is_admin: getBoolVal(
                                sessionStorage.getItem("is_admin"),
                              ),
                            }),
                          );
                          dispatch(
                            reportsExpDetails(
                              { report_id: params.id },
                              {
                                is_admin: getBoolVal(
                                  sessionStorage.getItem("is_admin"),
                                ),
                              },
                            ),
                          );
                        }}
                      />
                      <Row className="mt1">
                        <Col span={6} offset={18}>
                          <div className="totalsSection">
                            <p>
                              Total Expense Amount
                              <span>
                                <BaseCurrency />{" "}
                                {amountFormat(reportData?.total_amount) || 0}
                              </span>
                            </p>
                            <p>
                              Non-reimbursable Amount
                              <span>
                                {" "}
                                <BaseCurrency />{" "}
                                {amountFormat(
                                  reportData?.total_non_reimbursable_amount,
                                ) || 0}
                              </span>
                            </p>
                            <p>
                              Advance Amount
                              <span>
                                {" "}
                                <BaseCurrency />{" "}
                                {amountFormat(
                                  reportData?.total_advances_amount,
                                ) || 0}
                              </span>
                            </p>
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt1 ">
                        <Col span={24}>
                          <div className="totalBar">
                            <p>
                              {reportData?.status === "reimbursed"
                                ? "Reimbursed Amount"
                                : "Amount to be Reimbursed"}
                              <span>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <BaseCurrency />{" "}
                                {amountFormat(
                                  reportData?.total_amount -
                                  reportData?.total_non_reimbursable_amount -
                                  reportData?.total_advances_amount,
                                ) || 0}
                              </span>
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    <NodataComponent />
                  )}
                </Panel>
                {reportData?.status !== "unsubmitted" ||
                  getBoolVal(sessionStorage.getItem("is_admin")) ? null : (
                  <div className="floatRightButtons mr1">
                    <Button
                      key="2"
                      className="cancelButton ml1 mt1"
                      onClick={() => {
                        setIsModalVisible(true);
                        setModalType("addUnrepAdvance");
                      }}
                    >
                      Apply Advance
                    </Button>
                  </div>
                )}
                <Panel
                  header={
                    <span>
                      Advances <strong>{reportsAdvanceData.length}</strong>
                    </span>
                  }
                  key="2"
                >
                  {reportsAdvanceData.length ? (
                    <ReportAdvances
                      reportsAdvanceData={reportsAdvanceData}
                      reportStatus={reportData?.status}
                      callExpenseDetails={() => {
                        dispatch(
                          userReport({
                            id: params.id,
                            is_admin: getBoolVal(
                              sessionStorage.getItem("is_admin"),
                            ),
                          }),
                        );
                        dispatch(
                          reportsAdvance(
                            { report_id: params.id },
                            {
                              is_admin: getBoolVal(
                                sessionStorage.getItem("is_admin"),
                              ),
                            },
                          ),
                        );
                      }}
                    />
                  ) : (
                    <NodataComponent
                      msg={
                        "You don’t have any advances associated with this report."
                      }
                    />
                  )}
                </Panel>
                {reportData?.status !== "unsubmitted" ||
                  getBoolVal(sessionStorage.getItem("is_admin")) ? null : (
                  <div className="floatRightButtons mr1">
                    <Button
                      key="2"
                      className="cancelButton ml1 mt1"
                      onClick={() => {
                        setIsModalVisible(true);
                        setModalType("addUnrepTrip");
                      }}
                    >
                      Link Trip
                    </Button>
                  </div>
                )}
                <Panel
                  header={
                    <span>
                      Trips <strong>{reportsTripData.length}</strong>
                    </span>
                  }
                  key="3"
                >
                  {reportsTripData.length ? (
                    <ReportTrips
                      reportsTripData={reportsTripData}
                      reportStatus={reportData?.status}
                      callExpenseDetails={() => {
                        dispatch(
                          userReport({
                            id: params.id,
                            is_admin: getBoolVal(
                              sessionStorage.getItem("is_admin"),
                            ),
                          }),
                        );
                        dispatch(
                          reportsTrips(
                            { report_id: params.id },
                            {
                              is_admin: getBoolVal(
                                sessionStorage.getItem("is_admin"),
                              ),
                            },
                          ),
                        );
                      }}
                    />
                  ) : (
                    <NodataComponent
                      msg={
                        "You don’t have any trips associated with this report"
                      }
                    />
                  )}
                </Panel>
                <Panel
                  header={
                    <span>
                      Comments <strong>{commentsData.length}</strong>
                    </span>
                  }
                  key="4"
                >
                  <div className="addComment mt2 mb1">
                    <Input
                      placeholder="Enter Comment"
                      value={input}
                      onChange={(e) => setInput(e.target.value.trimStart())}
                    />
                    <Button
                      key="1"
                      className="formButton ml1"
                      onClick={() => handleAddComment()}
                    >
                      Send
                    </Button>
                  </div>
                  {commentsData.length ? (
                    <>
                      <div className="commentsSection mt2">
                        <Steps
                          direction="vertical"
                          size="small"
                          current={commentsData.length + 1 || 100}
                        >
                          {commentsData &&
                            commentsData.map(
                              ({ body, created_at, user_name, id }) => (
                                <Step
                                  key={id}
                                  title={body}
                                  description={
                                    formatCommentTimestamp(created_at) +
                                    " / " +
                                    user_name
                                  }
                                  icon={
                                    <img
                                      src={Comment}
                                      alt="history"
                                      width={18}
                                    />
                                  }
                                />
                              ),
                            )}
                        </Steps>
                      </div>
                    </>
                  ) : (
                    <NoCommentsComponent />
                  )}
                </Panel>
                <Panel
                  header={
                    <span>
                      History <strong>{reportsHistoryData.length}</strong>
                    </span>
                  }
                  key="5"
                  className="mb4"
                >
                  {reportsHistoryData.length ? (
                    <div className="commentsSection mt2">
                      <Steps
                        direction="vertical"
                        size="small"
                        current={reportsHistoryData.length + 1 || 100}
                      >
                        {reportsHistoryData &&
                          reportsHistoryData.map(
                            ({ body, created_at, user_name, id, status }) => (
                              <Step
                                key={id}
                                title={body}
                                description={
                                  formatCommentTimestamp(created_at) +
                                  " | " +
                                  user_name +
                                  " | Action: " +
                                  status
                                }
                                icon={
                                  <img src={History} alt="history" width={18} />
                                }
                              />
                            ),
                          )}
                      </Steps>
                    </div>
                  ) : (
                    <NodataComponent />
                  )}
                </Panel>
              </Collapse>
            </div>
            <ReimburseModal
              title={"Record Reimbursement"}
              open={reimburseModalVisible}
              handleCancel={() => {
                setReimburseModalVisible(false);
              }}
              id={params.id}
              onSubmit={(vals) => {
                dispatch(reportsReimburse(vals));
              }}
              isPositive={
                reportData?.total_amount - reportData?.total_advances_amount >=
                0
              }
              total_amount={reportData?.total_amount}
              total_advances_amount={reportData?.total_advances_amount}
              loading={reportsReimburseResponse?.loading}
            />
          </div>
        ) : (
          <div className="report-detail detail-card mb4">
            {`You don't have permissions to view this report`}
          </div>
        )}
      </>
      <Modal
        title={<Title level={4}>Policy Violation Information</Title>}
        visible={showViolations}
        onCancel={() => {
          setShowViolations(false);
        }}
        footer={[]}
      >
        <div className="violations">
          {violations?.map((ele, idx) => (
            <div className="item">
              {idx + 1}. {ele.report_number} -
              {ele.policies?.map((itm) =>
                itm.errors.map((e) => (
                  <span className={itm.is_warning ? "warn" : ""}>
                    <img
                      src={itm.is_warning ? warn : block}
                      alt=""
                      width={12}
                    />{" "}
                    {e}
                  </span>
                )),
              )}
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default ReportDetail;
